import React from 'react';
import { Button, Typography } from '@mui/material';
import {ReactComponent as UpgradeStarIcon} from '../static/icons/Upgrade Star.svg'

const SubscriptionPlanCard = ({
  isActive = false,
  isPremium = true,
  onClick = () => {}
}) => {
  const cardStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '285px',
    height: '446px',
    padding: '16px',
    margin: '0 auto',
    position: 'relative',
    borderRadius: '24px',
    border: `2.5px solid ${isPremium ? '#5D2A79' : 'transparent'}`,
    background: isPremium 
      ? 'linear-gradient(144deg, #1D151D 42.84%, #4E2D33 179.39%)' 
      : 'white',
    boxShadow: '10px 10px 80px 0px rgba(63, 39, 102, 0.10)',
    backdropFilter: 'blur(10px)',
    color: isPremium ? '#E1E1E6' : '#333'
  };

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '24px'
  };

  const titleStyle = {
    color: isPremium ? '#E1E1E6' : '#333',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '140%'
  };

  const subtitleStyle = {
    display: 'block',
    color: isPremium ? '#E1E1E6' : '#333',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontWeight: '300'
  };

  const descriptionContainerStyle = {
    flexGrow: 1,
    display: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '50px'
  };

  const descriptionStyle = {
    color: isPremium ? '#BBA4AB' : '#666',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px'
  };

  const subscribedStyle = {
    color: isPremium ? '#BBA4AB' : '#666',
    fontWeight: '600',
    marginTop: '24px',
    fontFamily: 'Poppins',
    height: '8%',
  };

  const featureItemStyle = {
    color: isPremium ? '#E1E1E6' : '#666',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    textAlign: 'left',
    margin: '6px 0',
    display: 'flex',
    alignItems: 'flex-start'
  };

  const bulletPointStyle = {
    color: isPremium ? '#BBA4AB' : '#666',
    marginRight: '8px',
    fontWeight: 'bold'
  };

  return (
    <div style={cardStyle}>
      <div style={contentStyle}>
        <div style={headerStyle}>
          <h3 style={titleStyle}>{isPremium ? "Premium (Monthly)" : "Free" }</h3>
          {/* <span style={subtitleStyle}>{isPremium ? "10.00 SGD" : ""}</span> */}
        </div>
        
        <div style={descriptionContainerStyle}>
          {/* <p style={descriptionStyle}>{isPremium ? "Full features" : "Limited use"}</p> */}
          {isPremium ? (
            <>
              <p style={featureItemStyle}>
                <span style={bulletPointStyle}>•</span> Full access to questions 📚
              </p>
              <p style={featureItemStyle}>
                <span style={bulletPointStyle}>•</span> Unlimited AI insights 🚀
              </p>
              <p style={featureItemStyle}>
                <span style={bulletPointStyle}>•</span> Unlocked premium features ✨ <br/> 🔍 Resume Evaluator <br/> 💬 Virtual interviewer <br/> 🎯 Tailored recommendations
              </p>
            </>
          ) : (
            <>
              <p style={featureItemStyle}>
                <span style={bulletPointStyle}>•</span> Full access to questions 📚
              </p>
              <p style={featureItemStyle}>
                <span style={bulletPointStyle}>•</span> First 5 AI insights free 🤖
              </p>
              <p style={featureItemStyle}>
                <span style={bulletPointStyle}>•</span> No premium features 🔒
              </p>
            </>
          )}
        </div>
        
        {isActive ? (
          <div style={subscribedStyle}>Subscribed!</div>
        ) : (
          isPremium ? (
            <Button 
              onClick={onClick}
              sx={{
                width: '65%',
                height: '12%',
                display: 'flex', 
                gap: 2, 
                textTransform: 'none',
                background: '#F3F3F31A',
                border: '1px solid #FFFFFF73',
                borderRadius: '24px',
                boxShadow: '10px 10px 80px 0px #3F27661A',
            }}>
                <UpgradeStarIcon/>
                <Typography sx={{color: '#E1E1E6'}}>10 SGD</Typography>
            </Button>
          ) : (
            <Typography sx={{color: 'grey'}}>Downgrade above</Typography>
          )
        )}
      </div>
    </div>
  );
};

export default SubscriptionPlanCard;

